import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import {
  FamilyApplication2f6semoy1a9hz as FamilyApplication,
  Companion_getInstancevgnjncsigc6q as Companion_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/applications.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  get_notNull2od35hy6ssmdh as get_notNull,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_createdAt3vhv4gzp0xb8r as get_createdAt,
  get_email13agc7d6ft82j as get_email,
  get_managesFamiliesqhp25q3m346r as get_managesFamilies,
  get_primaryParent1y63p7tb3kpdx as get_primaryParent,
  get_email2vebsqfvcm8pu as get_email_0,
  get_secondaryParent11vqc6r832a2n as get_secondaryParent,
  get__id336i6k806byxy as get__id,
  get_sentTo321ekxiln2x6w as get_sentTo,
  get_review35f4yosw8k9cn as get_review,
  get_approved3bkx12y4t4oji as get_approved,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  allTextFieldsContain2y4ctgpgxc740 as allTextFieldsContain,
  textSearchConditionr2nfggw95qef as textSearchCondition,
  searchField2rc6mst1no9ok as searchField,
} from '../components/search.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
  maxWidth22r11xnm7d4h4 as maxWidth,
  sortSelect2bs9xha2fqnl1 as sortSelect,
  addButton16duilic9iyqp as addButton,
} from '../components/view-utilities.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  BannerSemantic_getInstance18p0b4btg61q8 as BannerSemantic_getInstance,
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
} from '../../theme/semantics.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { text189ciz0cnr32o as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { withStringBufferw9sv07w4j3wo as withStringBuffer } from '../components/validation.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { singleSelectsi94opizn1pu as singleSelect } from '../components/singleSelectField.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  Always_getInstance177eud73uc475 as Always_getInstance,
  and3dbt2f202um49 as and,
  or1uh2qn0k1rz6c as or,
  And1a3dbpwh0hxmu as And,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  await1xlt6i5aa076q as await_0,
  await1uwe8zvsjq69o as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  IDqqik72jjbpsn as ID,
  Family2k7vz7ddyergb as Family,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import {
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { User3mqs8plvl8nwo as User } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import {
  eq353yrgcpovoi1 as eq,
  neqpgb3jcwulnab as neq,
  inside26mvda7ucvpq5 as inside,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { FamilyApplicationDetailPage3ca1ne4h64yjy as FamilyApplicationDetailPage } from './FamilyApplicationDetailPage.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_1,
  toDuration28gf6ughsr3vf as toDuration,
  toDuration7gy6v749ektt as toDuration_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { debounce3vjzafx7e7d30 as debounce } from '../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  FamilyApplicationFilters22j6eillzfykb as FamilyApplicationFilters,
  familyApplicationFilters2tdeb6ukk6qtj as familyApplicationFilters,
  familyApplicationFilterChipsqwf7ta9j5r3j as familyApplicationFilterChips,
} from './FamilyApplicationFilters.mjs';
import {
  first58ocm7j58k3q as first,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_atBottomStart1iulwjfo1udg3 as get_atBottomStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_1,
  tableRecycler8sos3tuo7qum as tableRecycler,
} from '../components/table.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function FamilyApplicationsListPage$SortOption$Companion$_anonymous__4e82ms() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.applications.FamilyApplicationsListPage.SortOption', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$4);
  this_0.descending_tl4o2_k$(get_createdAt(it));
  var tmp$ret$0 = this_0.build_1k0s4u_k$();
  SortOption_NewestFirst_instance = new (SortOption())('NewestFirst', 0, 'Newest first', tmp$ret$0);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
  var tmp$ret$10 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$10);
  this_1.ascending_ijynum_k$(get_createdAt(it_0));
  var tmp$ret$6 = this_1.build_1k0s4u_k$();
  SortOption_OldestFirst_instance = new (SortOption())('OldestFirst', 1, 'Oldest first', tmp$ret$6);
  if (Companion_instance_2 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var SortOption_NewestFirst_instance;
var SortOption_OldestFirst_instance;
function values() {
  static_init();
  return [SortOption_NewestFirst_getInstance(), SortOption_OldestFirst_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, FamilyApplicationsListPage$SortOption$Companion$_anonymous__4e82ms);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  static_init();
  return Companion_instance_2;
}
var $ENTRIES;
var SortOptionClass;
function SortOption() {
  if (SortOptionClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, sort) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.sort_1 = sort;
      }
    }
    initMetadataForClass($, 'SortOption', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    SortOptionClass = $;
  }
  return SortOptionClass;
}
function FamilyApplicationsListPage$_get_title_$lambda_2b037i($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationListTitle_c6ygp5_k$();
}
function FamilyApplicationsListPage$data$lambda$lambda(word) {
  return allTextFieldsContain(Companion_getInstance().serializer_9w0wvi_k$(), word);
}
function FamilyApplicationsListPage$render$lambda($this$invoke) {
  return 'Pending Family Invites';
}
function FamilyApplicationsListPage$render$lambda$lambda(it) {
  return it.displayName_1;
}
function FamilyApplicationsListPage$render$lambda_0($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function FamilyApplicationsListPage$render$lambda_1($this$addButton) {
  return 'Invite family';
}
function FamilyApplicationsListPage$render$lambda_2($this$addButton) {
  $this$addButton.set_action_2ds022_k$(Action('Invite family', VOID, VOID, VOID, VOID, VOID, FamilyApplicationsListPage$render$lambda$slambda($this$addButton)));
  return Unit_instance;
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda($this$dialog, close) {
  var email = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
  var employer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = sizeConstraints($this$dialog, get_standardDialogWidth());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var this_1 = themed(element, BannerSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_2 = themed(this_1, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(true);
  text(element_1, 'A user with this email will be created.');
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element.willAddChild_hz2iwc_k$(element_2);
  element_2.set_content_lzqutq_k$('Email');
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_3 = themed(element_2, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (TextInput())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  element_3.bind_gesskf_k$(element_3.content_1, withStringBuffer(validated(email)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  errorText(element_2);
  element_2.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var label = 'Employer';
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element.willAddChild_hz2iwc_k$(element_4);
  element_4.set_content_lzqutq_k$(label);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_2 = themed(element_4, FieldSemantic_getInstance());
  var tmp_3 = remember(VOID, VOID, VOID, VOID, FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda_0);
  singleSelect(tmp_2, employer, tmp_3, FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda_1, 'None selected');
  element_4.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (Separator())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  element.willAddChild_hz2iwc_k$(element_5);
  element_5.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  element.willAddChild_hz2iwc_k$(element_6);
  element_6.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_4 = themed(element_6, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = new (Button())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  this_4.willAddChild_hz2iwc_k$(element_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = new (TextView())(element_7.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  element_7.willAddChild_hz2iwc_k$(element_8);
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl(element_8);
  var tmp_6 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb(element_8));
  element_8.invoke_bnq13k_k$(tmp_6, FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda_2);
  element_8.onStartup_vrxh3i_k$();
  element_7.addChild_2qpft2_k$(element_8);
  onClick(element_7, VOID, VOID, VOID, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda(close));
  element_7.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_7);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_5 = weight(element_6, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = new (Space())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  this_5.willAddChild_hz2iwc_k$(element_9);
  element_9.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_9);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_6 = themed(element_6, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_7 = themed(this_6, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_10 = new (Button())(this_7.get_context_h02k06_k$());
  ensureOutermostElement(element_10);
  this_7.willAddChild_hz2iwc_k$(element_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_11 = new (TextView())(element_10.get_context_h02k06_k$());
  ensureOutermostElement(element_11);
  element_10.willAddChild_hz2iwc_k$(element_11);
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl(element_11);
  var tmp_9 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb(element_11));
  element_11.invoke_bnq13k_k$(tmp_9, FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda_3);
  element_11.onStartup_vrxh3i_k$();
  element_10.addChild_2qpft2_k$(element_11);
  element_10.set_action_2ds022_k$(Action('Invite family', VOID, VOID, VOID, VOID, VOID, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda_0(employer, email, element_10, close)));
  element_10.onStartup_vrxh3i_k$();
  this_7.addChild_2qpft2_k$(element_10);
  element_6.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_6);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda($this$invoke) {
  return 'Invite family';
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda_0($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().query_so6xq1_k$(new (Query())(Always_getInstance(), VOID, VOID, 2147483647)));
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda_1(it) {
  return it.name_1;
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$lambda_3($this$invoke) {
  return 'Invite family';
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda($this$invoke) {
  return 'Repeated email';
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda_0($this$invoke) {
  return 'This email is already associated with the following families/applications:';
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda_1($fam) {
  return ($this$invoke) => '\u2022 ' + $fam.get_distinctName_5wyy9c_k$();
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda_2($this$invoke) {
  return 'Please confirm the email before sending an invite.';
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda_3($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$slambda($closeInner) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $closeInner();
    return Unit_instance;
  }), 0);
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$slambda_0($closeInner, $session, $chosenEmployer, $sentTo, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $closeInner();
    yield* $session.get_familyApplications_uxaw4w_k$().add_co22jy_k$(new (FamilyApplication())(VOID, $chosenEmployer, $sentTo), $completion);
    $close();
    return Unit_instance;
  }), 0);
}
function FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda_0($employer, $email, $$this$button, $close) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $employer;
    var tmp = yield* await_0(this_0, $completion);
    var tmp0_elvis_lhs = tmp == null ? null : tmp.raw_1;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var chosenEmployer = tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $email;
    var tmp_2 = yield* await_0(this_1, $completion);
    var tmp1_elvis_lhs = tmp_2 == null ? null : tmp_2.raw_1;
    var tmp_3;
    var tmp_4 = tmp1_elvis_lhs;
    if ((tmp_4 == null ? null : new (EmailAddress())(tmp_4)) == null) {
      return Unit_instance;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var sentTo = tmp_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    var session = yield* await_1(this_2, $completion);
    var tmp_5 = session.get_users_izsycf_k$();
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_6 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$6 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
    new (DataClassPathSelf())(tmp$ret$6);
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_7 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$10 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$10);
    var tmp$ret$7 = and(eq(get_email(it), new (EmailAddress())(sentTo)), neq(get_managesFamilies(it), emptySet()));
    var tmp$ret$3 = new (Query())(tmp$ret$7, orderBy, 0, 100);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = tmp_5.query_so6xq1_k$(tmp$ret$3);
    var usersManagingFamilies = yield* await_1(this_3, $completion);
    var tmp_8 = session.get_families_is4v1x_k$();
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy_0 = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_9 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
    var tmp$ret$17 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
    new (DataClassPathSelf())(tmp$ret$17);
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_10 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
    var tmp$ret$21 = isInterface(tmp_10, KSerializer()) ? tmp_10 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it_0 = new (DataClassPathSelf())(tmp$ret$21);
    var tmp_11 = or(eq(get_email_0(get_primaryParent(it_0)), new (EmailAddress())(sentTo)), eq(get_email_0(get_notNull(get_secondaryParent(it_0))), new (EmailAddress())(sentTo)));
    var tmp_12 = get__id(it_0);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = usersManagingFamilies.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var list = element.managesFamilies_1;
      addAll(destination, list);
    }
    var tmp$ret$18 = or(tmp_11, inside(tmp_12, destination));
    var tmp$ret$14 = new (Query())(tmp$ret$18, orderBy_0, 0, 100);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = tmp_8.query_so6xq1_k$(tmp$ret$14);
    var existingFamilies = yield* await_1(this_4, $completion);
    var tmp_13 = session.get_familyApplications_uxaw4w_k$();
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy_1 = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_14 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
    var tmp$ret$31 = isInterface(tmp_14, KSerializer()) ? tmp_14 : THROW_CCE();
    new (DataClassPathSelf())(tmp$ret$31);
    // Inline function 'com.lightningkite.services.database.condition' call
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_15 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
    var tmp$ret$35 = isInterface(tmp_15, KSerializer()) ? tmp_15 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it_1 = new (DataClassPathSelf())(tmp$ret$35);
    var tmp$ret$32 = and(eq(get_sentTo(it_1), new (EmailAddress())(sentTo)), or(eq(get_review(it_1), null), eq(get_approved(get_notNull(get_review(it_1))), false)));
    var tmp$ret$28 = new (Query())(tmp$ret$32, orderBy_1, 0, 100);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = tmp_13.query_so6xq1_k$(tmp$ret$28);
    // Inline function 'kotlin.collections.partition' call
    var this_6 = yield* await_1(this_5, $completion);
    var first = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var second = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_0 = this_6.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      if (element_0.review_1 == null) {
        first.add_utx5q5_k$(element_0);
      } else {
        second.add_utx5q5_k$(element_0);
      }
    }
    var _destruct__k2r9zo = new (Pair())(first, second);
    var openApplications = _destruct__k2r9zo.component1_7eebsc_k$();
    var cancelledApplications = _destruct__k2r9zo.component2_7eebsb_k$();
    var tmp_16;
    var tmp_17;
    var tmp_18;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!existingFamilies.isEmpty_y1axqb_k$()) {
      tmp_18 = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_18 = !openApplications.isEmpty_y1axqb_k$();
    }
    if (tmp_18) {
      tmp_17 = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_17 = !cancelledApplications.isEmpty_y1axqb_k$();
    }
    if (tmp_17) {
      var tmp_19 = $$this$button.get_context_h02k06_k$();
      dialog(tmp_19, VOID, ($this$dialog, closeInner) => {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = sizeConstraints($this$dialog, get_standardDialogWidth());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
        element_0.invoke_bnq13k_k$(tmp_1, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_4, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda_0);
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.compact' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_1.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_2 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !existingFamilies.isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_2.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        var _iterator__ex2g4s = existingFamilies.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var fam = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
          ensureOutermostElement(element_4);
          element_3.willAddChild_hz2iwc_k$(element_4);
          var tmp_5 = KMutableProperty0();
          var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_4);
          var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_4));
          element_4.invoke_bnq13k_k$(tmp_7, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda_1(fam));
          element_4.onStartup_vrxh3i_k$();
          element_3.addChild_2qpft2_k$(element_4);
        }
        element_3.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !openApplications.isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_3.willAddChild_hz2iwc_k$(element_5);
        var tmp_8 = KMutableProperty0();
        var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_10, ($this$invoke) => '\u2022 ' + openApplications.get_size_woubt6_k$() + ' open family application(s)');
        element_5.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_4 = shownWhen(element_2, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !cancelledApplications.isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (TextView())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_4.willAddChild_hz2iwc_k$(element_6);
        var tmp_11 = KMutableProperty0();
        var tmp_12 = TextView$_get_content_$ref_4pzcwl(element_6);
        var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(element_6));
        element_6.invoke_bnq13k_k$(tmp_13, ($this$invoke) => '\u2022 ' + cancelledApplications.get_size_woubt6_k$() + ' cancelled family application(s)');
        element_6.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_6);
        element_2.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_5 = get_bold(element);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (TextView())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_5.willAddChild_hz2iwc_k$(element_7);
        var tmp_14 = KMutableProperty0();
        var tmp_15 = TextView$_get_content_$ref_4pzcwl(element_7);
        var tmp_16 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb(element_7));
        element_7.invoke_bnq13k_k$(tmp_16, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda_2);
        element_7.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        element.willAddChild_hz2iwc_k$(element_8);
        element_8.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_6 = themed(element_9, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (Button())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_6.willAddChild_hz2iwc_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(element_10.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        element_10.willAddChild_hz2iwc_k$(element_11);
        var tmp_17 = KMutableProperty0();
        var tmp_18 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_19 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_19, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$lambda_3);
        element_11.onStartup_vrxh3i_k$();
        element_10.addChild_2qpft2_k$(element_11);
        onClick(element_10, VOID, VOID, VOID, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$slambda(closeInner));
        element_10.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_7 = weight(element_9, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (Space())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_7.willAddChild_hz2iwc_k$(element_12);
        element_12.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_8 = themed(element_9, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_9 = themed(this_8, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (Button())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_9.willAddChild_hz2iwc_k$(element_13);
        text(element_13, 'Send invite anyway');
        onClick(element_13, VOID, VOID, VOID, FamilyApplicationsListPage$render$lambda$slambda$lambda$slambda$lambda$slambda_0(closeInner, session, chosenEmployer, sentTo, $close));
        element_13.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_13);
        element_9.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_9);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        return Unit_instance;
      });
      return Unit_instance;
    }
    yield* session.get_familyApplications_uxaw4w_k$().add_co22jy_k$(new (FamilyApplication())(VOID, chosenEmployer, sentTo), $completion);
    $close();
    return Unit_instance;
  }), 1);
}
function FamilyApplicationsListPage$render$lambda$slambda($this_addButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $this_addButton.get_context_h02k06_k$();
    dialog(tmp, VOID, FamilyApplicationsListPage$render$lambda$slambda$lambda);
    return Unit_instance;
  }), 1);
}
function FamilyApplicationsListPage$render$lambda_3(it) {
  return new (FamilyApplicationDetailPage())(it._id_1);
}
function FamilyApplicationsListPage$render$lambda_4($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationColumnSentTo_7zvbzg_k$();
}
function FamilyApplicationsListPage$render$lambda_5($this$text, it) {
  return EmailAddress__toString_impl_artjh3(it.sentTo_1);
}
function FamilyApplicationsListPage$render$lambda_6($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationColumnEmployer_c2b99w_k$();
}
function FamilyApplicationsListPage$render$lambda_7($this$text, it) {
  var tmp0_safe_receiver = $this$text.invoke_r7m7el_k$($this$text.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().get_6ueaa7_k$(new (ID())(it.employer_1)));
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function FamilyApplicationsListPage$render$lambda_8($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationColumnInvitedAt_esy33p_k$();
}
function FamilyApplicationsListPage$render$lambda_9($this$text, it) {
  return renderToString(it.createdAt_1, RenderSize_Abbreviation_getInstance());
}
function FamilyApplicationsListPage$render$lambda_10($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationColumnStatus_87vyuj_k$();
}
function FamilyApplicationsListPage$render$lambda_11($this$custom, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  var tmp = themed(element, ChipSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = dynamicThemed(tmp, ($this$dynamicThemed) => {
    var tmp;
    var tmp0_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(it).review_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
      tmp = AffirmativeSemantic_getInstance();
    } else {
      var tmp1_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(it).review_1;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
        tmp = DangerSemantic_getInstance();
      } else {
        if ($this$dynamicThemed.invoke_r7m7el_k$(it).submission_1 == null) {
          tmp = null;
        } else {
          tmp = WarningSemantic_getInstance();
        }
      }
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_2, ($this$invoke) => {
    var tmp;
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(it).review_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
      tmp = 'Approved';
    } else {
      var tmp1_safe_receiver = $this$invoke.invoke_r7m7el_k$(it).review_1;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
        tmp = 'Cancelled';
      } else {
        if ($this$invoke.invoke_r7m7el_k$(it).submission_1 == null) {
          tmp = 'Invited';
        } else {
          tmp = 'Submitted';
        }
      }
    }
    return tmp;
  });
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function FamilyApplicationsListPage$render$lambda_12($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
function SortOption_NewestFirst_getInstance() {
  static_init();
  return SortOption_NewestFirst_instance;
}
function SortOption_OldestFirst_getInstance() {
  static_init();
  return SortOption_OldestFirst_instance;
}
var FamilyApplicationsListPageClass;
function FamilyApplicationsListPage() {
  if (FamilyApplicationsListPageClass === VOID) {
    class $ {
      constructor() {
        this.textSearch_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_1();
        var tmp$ret$0 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
        tmp.debouncedTextSearch_1 = debounce(this.textSearch_1, tmp$ret$0, get_AppScope());
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (FamilyApplicationFilters())());
        this.sort_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(first(get_entries()));
        var tmp_0 = this;
        tmp_0.data_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_familyApplications_uxaw4w_k$();
          var tmp_0 = $this$remember.invoke_r7m7el_k$(this.debouncedTextSearch_1);
          var tmp_1 = textSearchCondition(tmp_0, FamilyApplicationsListPage$data$lambda$lambda);
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$3);
          var tmp$ret$1 = eq(get_review(it), null);
          var tmp_3 = new (Query())(And().new_com_lightningkite_services_database_Condition_And_ln02sz_k$([tmp_1, tmp$ret$1, $this$remember.invoke_r7m7el_k$(this.filter_1).toCondition_oj74tc_k$()]), $this$remember.invoke_r7m7el_k$(this.sort_1).sort_1, VOID, 50);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_1();
          var tmp$ret$6 = toDuration_0(5, DurationUnit_MINUTES_getInstance());
          return tmp.list$default_sjz00l_k$(tmp_3, VOID, tmp$ret$6);
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, FamilyApplicationsListPage$_get_title_$lambda_2b037i);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_2.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = get_atBottomStart(element_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, FamilyApplicationsListPage$render$lambda);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_4 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        searchField(element_0, this.textSearch_1);
        sortSelect(element_0, ($this$sortSelect) => {
          var tmp = _Constant___init__impl__v45mub(toList(get_entries()));
          $this$sortSelect.bind_64a41i_k$(this.sort_1, new (Constant())(tmp), FamilyApplicationsListPage$render$lambda$lambda);
          return Unit_instance;
        });
        familyApplicationFilters(element_0, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_5 = shownWhen(element_0, false, VOID, FamilyApplicationsListPage$render$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Separator())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_3.willAddChild_hz2iwc_k$(element_4);
        element_4.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var tmp_2 = themed(element_3, ImportantSemantic_getInstance());
        var tmp_3 = FamilyApplicationsListPage$render$lambda_1;
        addButton(tmp_2, tmp_3, FamilyApplicationsListPage$render$lambda_2);
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        element_0.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_0);
        familyApplicationFilterChips(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_4 = weight(element, 1.0);
        var tmp_5 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.data_1));
        var tmp_6 = FamilyApplicationsListPage$render$lambda_3;
        var tmp_7 = Companion_instance_1;
        var tmp_8 = FamilyApplicationsListPage$render$lambda_4;
        var tmp_9 = tmp_7.text_y5ktm4_k$(tmp_8, 2.0, FamilyApplicationsListPage$render$lambda_5);
        var tmp_10 = Companion_instance_1;
        var tmp_11 = FamilyApplicationsListPage$render$lambda_6;
        var tmp_12 = tmp_10.text$default_gwb2zv_k$(tmp_11, VOID, FamilyApplicationsListPage$render$lambda_7);
        var tmp_13 = Companion_instance_1;
        var tmp_14 = FamilyApplicationsListPage$render$lambda_8;
        var tmp_15 = tmp_13.text$default_gwb2zv_k$(tmp_14, VOID, FamilyApplicationsListPage$render$lambda_9);
        var tmp_16 = Companion_instance_1;
        var tmp_17 = FamilyApplicationsListPage$render$lambda_10;
        tableRecycler(tmp_4, tmp_5, tmp_6, [tmp_9, tmp_12, tmp_15, tmp_16.custom$default_tn6l2s_k$(tmp_17, VOID, FamilyApplicationsListPage$render$lambda_11)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_6 = shownWhen(element, VOID, VOID, FamilyApplicationsListPage$render$lambda_12);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Space())(this_6.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_5);
        this_6.willAddChild_hz2iwc_k$(element_5);
        element_5.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_5);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'FamilyApplicationsListPage', FamilyApplicationsListPage, VOID, [Page()]);
    FamilyApplicationsListPageClass = $;
  }
  return FamilyApplicationsListPageClass;
}
//region block: exports
export {
  SortOption as SortOption1pk0fob8nf099,
  FamilyApplicationsListPage as FamilyApplicationsListPage36qv7eutg9abf,
};
//endregion

//# sourceMappingURL=FamilyApplicationsListPage.mjs.map
